import Authorizer from "@adapters/infrastructures/Authorizer";
import infrastructures from "./infrastructure";
import SalesHttp from "@adapters/infrastructures/SalesHttp";
import { AccountDetails } from "@domains/utils/AccountDetails";
export var cInfrastructures = infrastructures();
export var autorize = new Authorizer(cInfrastructures.localStorage, cInfrastructures.cookieStorage, cInfrastructures.sessionStorage);
export var accountDetails = new AccountDetails(cInfrastructures.localStorage, cInfrastructures.cookieStorage, cInfrastructures.sessionStorage);
export var salesHttp = new SalesHttp(autorize, cInfrastructures.localStorage);
